"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadingLayout = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const react_1 = require("react");
exports.LoadingLayout = (0, react_1.memo)(() => {
    return ((0, jsx_runtime_1.jsx)(material_1.Stack, { height: "100%", width: "100%", flex: 1, alignItems: "center", justifyContent: "center", children: (0, jsx_runtime_1.jsx)(material_1.CircularProgress, { size: 24, sx: {
                color: (theme) => theme.palette.primary.main,
            } }) }));
});
exports.LoadingLayout.displayName = "Loading";
